// resources/js/Pages/HallOfFame/hooks/useScriptData.js
import { useMemo } from 'react';
import { sortScripts } from '../utils/sorting';

export const useScriptData = (scripts, sortConfig) => {
    // Percentiles now come from PHP - no need to calculate!
    // Just add stable keys for React rendering
    const scriptsWithKeys = useMemo(() => {
        return scripts.map((script, index) => {
            // Create truly unique key combining id + index + criteria_name
            const uniqueKey = `${script.id}-${index}-${script.criteria_name || 'none'}`;
            
            return {
                ...script,
                uniqueKey
            };
        });
    }, [scripts]);
    
    // Sort the scripts based on sortConfig
    const sortedScripts = useMemo(() => {
        return sortScripts(scriptsWithKeys, sortConfig);
    }, [scriptsWithKeys, sortConfig]);
    
    return sortedScripts;
};